// French for WhyNow. English text is the key; a missing entry falls back to English.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Why now': 'Pourquoi maintenant',
  'one action, chosen by the highest-scoring reason': 'une action, choisie par la raison la mieux notée',
  'score': 'score',
  'Score': 'Score',
  'Reading the score…': 'Lecture du score…',
  'The next best action could not be read: {error}': 'La prochaine action n’a pas pu être lue : {error}',
  'Nothing has scored this person yet. The rules run at 05:00, and on every interaction, signal and commitment; until one of those happens there is no score and no reason to show.':
    'Cette personne n’a pas encore été notée. Les règles tournent à 05:00, et à chaque contact, signal et engagement ; d’ici là il n’y a ni score ni raison à montrer.',
  'Nothing is asking for a move: no open commitment with us, no signal in thirty days, and the cadence is being kept.':
    'Rien ne demande de geste : aucun engagement ouvert chez nous, aucun signal depuis trente jours, et la cadence est tenue.',

  // les verbes
  'send': 'écrire', 'call': 'appeler', 'meet': 'rencontrer',
  'research': 'documenter', 'introduce': 'faire présenter', 'wait': 'attendre',

  'written by the why_now skill; nobody has held it': 'écrit par la compétence why_now ; personne ne l’a retenu',
  'written by {by} · the rule text stays underneath': 'écrit par {by} · le texte de la règle reste dessous',
  'composed by the rules from the score breakdown': 'composé par les règles à partir du détail du score',
  'Runners-up': 'Autres raisons',

  'Done': 'Fait',
  'Dismiss': 'Écarter',
  'Why this score': 'Pourquoi ce score',
  'Hide the breakdown': 'Masquer le détail',
  'Marked done. It will not be proposed again until the data asks for it.':
    'Marqué comme fait. Ce ne sera reproposé que si les données le redemandent.',
  'Dismissed. It will not be proposed again for seven days.':
    'Écarté. Ce ne sera pas reproposé avant sept jours.',
  'No rule fired. The score is zero because nothing matched, not because nothing was looked at.':
    'Aucune règle n’a déclenché. Le score est nul parce que rien ne correspondait, pas parce que rien n’a été regardé.',
}, 'WhyNow');
